import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { BookingCta } from '../components/BookingCta';
import { useStudio } from '../contexts/StudioContext';
import { duration, euro } from '../utils/format';
export function Services() {
  const {
    services,
    extras
  } = useStudio();
  return <>
      <section className="mx-auto max-w-shell px-5 pb-8 pt-24 sm:px-6 sm:pt-32 lg:px-10 lg:pt-44" data-id="element-1093" data-mp="15byace9kddd">
        <Reveal className="max-w-3xl" data-id="element-1094" data-mp="3ta77vlmf1q45">
          <span className="flex items-center gap-3" data-id="element-1095" data-mp="3t94dv4tsr7k0">
            <span className="hairline h-px w-10" aria-hidden="true" data-id="element-1096" data-mp="b4kpwylnpfwk" />
            <span className="text-[11px] uppercase tracking-[0.28em] text-ember" data-id="element-1097" data-mp="b1osrchmuv96">Diensten</span>
          </span>
          <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.03] tracking-tightest text-chalk sm:text-5xl" data-id="element-1098" data-mp="2cvebq3m8mtd0">
            Drie behandelingen. Geen opvulling.
          </h1>
        </Reveal>
      </section>

      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-1099" data-mp="16pcmc21mw588">
        {services.filter(s => s.active).map((service, i) => <Reveal key={service.id} data-id="element-1100" data-mp="1bo5pp1n7ifuo" data-mpi={i}>
            <section id={service.id} className="scroll-mt-28 grid items-center gap-10 border-b border-edge py-16 lg:grid-cols-2 lg:gap-20 lg:py-24" data-id="element-1101" data-mp="1fprcpftggail">
              <div className={`relative overflow-hidden rounded-2xl ${i % 2 === 1 ? 'lg:order-last' : ''}`} data-id="element-1102" data-mp="1pfau0h1irwbc">
                <img src={service.image} alt={service.name} className="h-[320px] w-full object-cover lg:h-[440px]" data-id="element-1103" data-mp="1ue5dzmb83qx1" />
                <span className="absolute left-5 top-5 rounded-full bg-void/70 px-3 py-1.5 text-xs uppercase tracking-[0.18em] text-ember backdrop-blur" data-id="element-1104" data-mp="23f3h82du7uek">
                  0{i + 1}
                </span>
              </div>

              <div data-id="element-1105" data-mp="90j4qczo7569">
                <h2 className="font-display text-2xl font-extrabold leading-tight tracking-tightest text-chalk sm:text-3xl" data-id="element-1106" data-mp="91u502twpusm">
                  {service.name}
                </h2>
                <p className="mt-4 max-w-md text-[15px] leading-relaxed text-dim" data-id="element-1107" data-mp="17donbfx0lgwr">{service.summary}</p>

                <ul className="mt-8 space-y-3.5 border-t border-edge pt-7" data-id="element-1108" data-mp="1lcwogecqmz3l">
                  {service.includes.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-chalk/85" data-id="element-1109" data-mp="1h9hz2x2wt6dh">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ember" aria-hidden="true" data-id="element-1110" data-mp="1v99ijdc73eyv" />
                      {item}
                    </li>)}
                </ul>

                <div className="mt-9 flex flex-wrap items-center gap-5" data-id="element-1111" data-mp="25045kjx9mild">
                  <span className="font-display text-2xl font-extrabold tracking-tight text-chalk" data-id="element-1112" data-mp="201aq4lyf4hik">
                    vanaf {euro(service.price)}
                  </span>
                  <span className="text-sm text-dim" data-id="element-1113" data-mp="292in90p77cb2">{duration(service.durationMinutes)}</span>
                  <Link to="/book" state={{
                serviceId: service.id
              }} className="group ml-auto inline-flex items-center gap-2 rounded-full bg-ember px-6 py-3.5 text-sm font-semibold text-void transition-[background-color,box-shadow] duration-200 ease-smooth hover:bg-white hover:glow" data-id="element-1114" data-mp="2so0yapf6f6ez">
                    Dit pakket boeken
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1115" data-mp="29xt1ep22lc78" />
                  </Link>
                </div>
              </div>
            </section>
          </Reveal>)}

        <Reveal data-id="element-1116" data-mp="24zhrkebrz1p0">
          <section className="py-16 lg:py-20" data-id="element-1117" data-mp="24yzmqtb1rf5h">
            <h2 className="font-display text-2xl font-extrabold tracking-tightest text-chalk sm:text-3xl" data-id="element-1118" data-mp="1qyoy7wx7mcnh">
              Extra's
            </h2>
            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3" data-id="element-1119" data-mp="1vwgnskadtmoi">
              {extras.filter(e => e.active).map(extra => <div key={extra.id} className="card-sheen overflow-hidden rounded-2xl border border-edge bg-carbon p-6 transition-colors duration-200 ease-smooth hover:border-ember/50" data-id="element-1120" data-mp="1ixpkjpsn0vh5">
                  <div className="flex items-baseline justify-between gap-4" data-id="element-1121" data-mp="1a5f8s423ghxs">
                    <h3 className="font-display text-lg font-extrabold text-chalk" data-id="element-1122" data-mp="157dr9nkbgqof">{extra.name}</h3>
                    <span className="font-display text-lg font-extrabold text-ember" data-id="element-1123" data-mp="106q2l8jk8lxd">+{euro(extra.price)}</span>
                  </div>
                  <p className="mt-2 text-sm text-dim" data-id="element-1124" data-mp="vahirhuf44jv">{extra.note}</p>
                </div>)}
            </div>
          </section>
        </Reveal>
      </div>

      <BookingCta data-id="element-1125" data-mp="2plw65rzyhrwg" />
    </>;
}